export const getPrimaryErrorCandidate = (error: unknown): Record<string, unknown> | null => {
  if (typeof error !== "object" || error === null) {
    return null;
  }

  const errorRecord = error as Record<string, unknown>;
  const firstNestedError = Array.isArray(errorRecord.errors) ? errorRecord.errors[0] : undefined;

  if (typeof firstNestedError === "object" && firstNestedError !== null) {
    return firstNestedError as Record<string, unknown>;
  }

  return errorRecord;
};
